import { Component, OnInit, Input, ElementRef, ViewChild, HostListener, Renderer2 } from '@angular/core';

@Component({
  selector: 'meu-zoom-image',
  templateUrl: './zoom-image.component.html',
  styleUrls: ['./zoom-image.component.scss']
})
export class ZoomImageComponent{


  posX: number = 0
  posY: number = 0
  cx: number = 1
  cy: number = 1
  yet: boolean = false
  factorX: number
  factorY: number

  @Input('img') imagen: string
  @Input() zoom;
  @Input() lenSize;
  @Input() imgWidth = 460;
  @Input() imgHeigth = 460;
  @Input() divZoomed: ElementRef

  @ViewChild('image', { static: false, read: ElementRef }) image
  @ViewChild('lens', { static: false, read: ElementRef }) lens

  @HostListener('mousemove', ['$event'])
  mouseMove(event: any) {
    const result = this.moveLens(event)

    this.render.setStyle(this.divZoomed, 'background-position', result)

    this.render.setStyle(this.divZoomed, 'opacity', 1)
  }

  @HostListener('mouseleave', ['$event'])
  mouseLeave(event: any) {
    this.render.setStyle(this.divZoomed, 'opacity', 0)
  }

  constructor(private render: Renderer2) {}

  onLoad() {
    this.render.setStyle(this.divZoomed, 'background-image', "url('" + this.imagen + "')")

    this.render.setStyle(
      this.divZoomed,
      'background-size',
      this.image.nativeElement.width * this.zoom +
        'px ' +
        this.image.nativeElement.height * this.zoom +
        'px'
    )

    this.render.setStyle(this.divZoomed, 'background-repeat', 'no-repeat')
    this.render.setStyle(this.divZoomed, 'transition', 'background-position .2s ease-out')

    this.factorX = this.image.nativeElement.width
    this.factorY = this.image.nativeElement.height
    this.yet = true

    setTimeout(() => {
      this.factorX =
        this.imgWidth || this.imgHeigth ? this.factorX / this.image.nativeElement.width : 1

      this.factorY =
        this.imgWidth || this.imgHeigth ? this.factorY / this.image.nativeElement.height : 1

      const dim = (this.divZoomed as any).getBoundingClientRect()

      this.cx =
        (dim.width - this.image.nativeElement.width * this.zoom * this.factorX) /
        (this.image.nativeElement.width - this.lens.nativeElement.offsetWidth)

      this.cy =
        (dim.height - this.image.nativeElement.height * this.zoom * this.factorY) /
        (this.image.nativeElement.height - this.lens.nativeElement.offsetHeight)
    })
  }

  moveLens(e: any) {
    let pos
    let x
    let y

    e.preventDefault()
    pos = this.getCursorPos(e)
    x = pos.x - this.lens.nativeElement.offsetWidth / 2
    y = pos.y - this.lens.nativeElement.offsetHeight / 2

    if (x > this.image.nativeElement.width - this.lens.nativeElement.offsetWidth) {
      x = this.image.nativeElement.width - this.lens.nativeElement.offsetWidth
    }

    if (x < 0) {
      x = 0
    }

    if (y > this.image.nativeElement.height - this.lens.nativeElement.offsetHeight) {
      y = this.image.nativeElement.height - this.lens.nativeElement.offsetHeight
    }

    if (y < 0) {
      y = 0
    }

    this.posX = x
    this.posY = y
    let result = x * this.cx + 'px ' + y * this.cy + 'px'

    return result
  }

  getCursorPos(e: any) {
    let a
    let x = 0
    let y = 0

    e = e || window.event
    a = this.image.nativeElement.getBoundingClientRect()
    x = e.pageX - a.left
    y = e.pageY - a.top
    x = x - window.pageXOffset
    y = y - window.pageYOffset

    return { x: x, y: y }
  }

}
